import { createSelector } from '@reduxjs/toolkit';
import {
    selectAvailabilityIsLoading,
    selectFinalOfferId,
    selectFinalOfferOptionId,
    selectOfferGroupIdFromSelectedOfferGroup,
    selectOfferLevelSelectedDate,
    selectPassengerOption,
} from 'component/page/detail/store/availabilitySelectorIndex';
import { Pax } from 'gql/autogen/Pax';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';

interface OwnProps {
    setIsDisplayWarning: (isDisplayWarning: boolean) => void;
    isDisplayWarning: boolean;
    offerIndex: number;
}

interface StateProps {
    isLoading: boolean;
    screenSize: ScreenSize;
    offerId: number | undefined;
    offerGroupId: number;
    paxState: Pax[];
    offerOptionId: number | undefined;
    offerLevelSelectedDate: Date | undefined;
}

export type OfferCardContainerProps = OwnProps & StateProps;
export const mapStateToProps = createSelector(
    selectAvailabilityIsLoading,
    selectScreenSize,
    selectFinalOfferId,
    selectOfferGroupIdFromSelectedOfferGroup,
    selectPassengerOption,
    selectFinalOfferOptionId,
    selectOfferLevelSelectedDate,
    (isLoading, screenSize, offerId, offerGroupId, paxState, offerOptionId, offerLevelSelectedDate): StateProps => {
        return {
            isLoading,
            screenSize,
            offerId,
            offerGroupId,
            paxState,
            offerOptionId,
            offerLevelSelectedDate,
        };
    },
);
